import { PlanTypes } from 'mbs-ui-shared@models/PlanTypes.enum';
import { WizardHelpersSettings } from 'wizards/helpers/bases/base-for-steps-helper';
import { PlanDataFromStepsHelper } from 'wizards/helpers/plan-data-from-steps-helper/plan-data-from-steps-helper';
import { VmwareFormModel } from 'wizards/models/VMWare/vmware-form-model';
import { BaseForVMPlanHelper } from '../bases/base-for-vm-plan-helper';

export class VmwarePlanFromStepsHelper extends BaseForVMPlanHelper {
  public static VmwareModel: VmwareFormModel = null;

  public static getUpdatedPlan(plan, model: VmwareFormModel, settings: WizardHelpersSettings): any {
    this.VmwareModel = model;
    const newPlan = Object.assign({}, plan);
    this.updateModel(newPlan, settings);
    return newPlan;
  }

  static updateModel(newPlan, settings: WizardHelpersSettings): void {
    this.isNBF = settings.isNBF;
    this.isNetBuild = settings.isNetBuild;
    this.isNBFWithHybrid = settings.isNBF && this.canHybridOnNbf(settings.agentVersion);
    const forceRemoveAppAware = !settings.isAppAwareEnabled;

    PlanDataFromStepsHelper.updateNewPlanByNameStep(newPlan, this.VmwareModel.planNameStep);

    if (this.isNBFWithHybrid) {
      PlanDataFromStepsHelper.updateNewPlanNBFHybridByWhereBackupStep(
        newPlan,
        this.VmwareModel.whereBackupStep,
        this.isUnix && !this.isNetBuild
      );
    } else
      PlanDataFromStepsHelper.updateNewPlanByWhereBackupStep(
        newPlan,
        this.VmwareModel.whereBackupStep,
        this.isNBF || (this.isUnix && !this.isNetBuild)
      );

    PlanDataFromStepsHelper.updateNewPlanByVirtualAdvancedSettings(
      newPlan,
      this.VmwareModel.advancedSettingsStep,
      false,
      false,
      this.isNBF
    );

    PlanDataFromStepsHelper.updateNewPlanBySelectHostStep(newPlan, this.VmwareModel.selectHostStep);
    PlanDataFromStepsHelper.updateNewPlanBySelectVirtualMachineStep(newPlan, this.VmwareModel.selectVirtualMachinesStep);

    if (this.isNBF) {
      PlanDataFromStepsHelper.updateNewPlanByAppAwareStep(newPlan, this.VmwareModel.appAwareStep, forceRemoveAppAware);
      PlanDataFromStepsHelper.updateNewPlanArchiveByArchiveConsistencyStep(newPlan, this.VmwareModel.archiveConsistencyStep);
      PlanDataFromStepsHelper.updateNewNBFPlanByScheduleStep(newPlan, this.VmwareModel.scheduleStep);
      PlanDataFromStepsHelper.updateNewNBFPlanByRetentionPolicyStep(newPlan, this.VmwareModel.retentionPolicyStep, true);

      if (this.isNBFWithHybrid) {
        PlanDataFromStepsHelper.updateNewNBFPlanWithHybridByRetentionPolicyStep(newPlan, this.VmwareModel.retentionPolicyStep);
      }
    } else {
      PlanDataFromStepsHelper.updateNewPlanByRetentionPolicyStep(
        newPlan,
        this.VmwareModel.retentionPolicyStep,
        this.VmwareModel.whereBackupStep.IsHybridBackup,
        this.isUnix && !this.isNetBuild,
        PlanTypes.BackupVMware
      );
      PlanDataFromStepsHelper.updateNewPlanByScheduleStep(
        newPlan,
        this.VmwareModel.scheduleStep,
        this.VmwareModel.scheduleAdvancedStep,
        this.VmwareModel.simpleScheduleStep,
        this.isUnix && !this.isNetBuild
      );
    }

    if (!this.VmwareModel.selectVirtualMachinesStep.machinesFullFormat.some((m) => m.notLoaded)) {
      PlanDataFromStepsHelper.updateNewPlanBySelectVirtualDisksStep(newPlan, this.VmwareModel.selectVirtualDisksStep, true);
    }

    PlanDataFromStepsHelper.updateNewPlanByCompressionEncryptionStep(newPlan, this.VmwareModel.compressionEncryptionStep, this.isNBF);
    PlanDataFromStepsHelper.updateNewPlanByPrePostActionsStep(newPlan, this.VmwareModel.prePostActionsStep, !settings.allowPrePostActions);
    PlanDataFromStepsHelper.updateNewPlanByNotificationStep(newPlan, this.VmwareModel.notificationStep, this.isUnix && !this.isNetBuild);
    PlanDataFromStepsHelper.preparePlanForSending(newPlan, false);
  }
}
